 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import FRONTMATTER from '@/components/frontmatter'
 import TITLEPAGE from '@/components/titlepage'
 import COPYRIGHTPAGE from '@/components/copyright-page'
 import INFORMATION from '@/components/Information'
 import DEDICATION from '@/components/dedication'
 import CONTENTS from '@/components/contents'
 import PART01 from '@/components/part01'
 import CHAPTER01 from '@/components/chapter01'
 import CHAPTER02 from '@/components/chapter02'
 import CHAPTER03 from '@/components/chapter03'
 import CHAPTER04 from '@/components/chapter04'
 import CHAPTER05 from '@/components/chapter05'
 import CHAPTER06 from '@/components/chapter06'
 import CHAPTER07 from '@/components/chapter07'
 import PART02 from '@/components/part02'
 import CHAPTER08 from '@/components/chapter08'
 import CHAPTER09 from '@/components/chapter09'
 import CHAPTER10 from '@/components/chapter10'
 import CHAPTER11 from '@/components/chapter11'
 import CHAPTER12 from '@/components/chapter12'
 import CHAPTER13 from '@/components/chapter13'
 import CHAPTER14 from '@/components/chapter14'
 import CHAPTER15 from '@/components/chapter15'
 import CHAPTER16 from '@/components/chapter16'
 import CHAPTER17 from '@/components/chapter17'
 import CHAPTER18 from '@/components/chapter18'
 import CHAPTER19 from '@/components/chapter19'
 import CHAPTER20 from '@/components/chapter20'
 import CHAPTER21 from '@/components/chapter21'
 import CHAPTER22 from '@/components/chapter22'
 import CHAPTER23 from '@/components/chapter23'
 import PART03 from '@/components/part03'
 import CHAPTER24 from '@/components/chapter24'
 import CHAPTER25 from '@/components/chapter25'
 import CHAPTER26 from '@/components/chapter26'
 import CHAPTER27 from '@/components/chapter27'
 import CHAPTER28 from '@/components/chapter28'
 import CHAPTER29 from '@/components/chapter29'
 import CHAPTER30 from '@/components/chapter30'
 import CHAPTER31 from '@/components/chapter31'
 import CHAPTER32 from '@/components/chapter32'
 import CHAPTER33 from '@/components/chapter33'
 import CHAPTER34 from '@/components/chapter34'
 import CHAPTER35 from '@/components/chapter35'
 import CHAPTER35A from '@/components/chapter35a'
 import CHAPTER35B from '@/components/chapter35b'
 import CHAPTER35C from '@/components/chapter35c'
 import CHAPTER35D from '@/components/chapter35d'
 import CHAPTER35E from '@/components/chapter35e'
 import CHAPTER35F from '@/components/chapter35f'
 import CHAPTER36 from '@/components/chapter36'
 import CHAPTER37 from '@/components/chapter37'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/part01",
 			"name" : "part01",
 			"component" : PART01
 		},
 		{
 			"path" : "/chapter01",
 			"name" : "chapter01",
 			"component" : CHAPTER01
 		},
 		{
 			"path" : "/chapter02",
 			"name" : "chapter02",
 			"component" : CHAPTER02
 		},
 		{
 			"path" : "/chapter03",
 			"name" : "chapter03",
 			"component" : CHAPTER03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js